import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort,  } from '../../../shared/utility';
import { apcologo, lightningHandLogo, shamalAzzourLogo, ministryLogo, newKuwaitLogo, boldArabicFont, securityStamp, securityPositionFalah, securitySignatureFalah, securityPositionAnezi, securitySignatureAnezi, securityPositionJaseer, securitySignatureJaseer, chenthoorLandscapeLogo } from '../../../shared/fontsAndBitImages';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { DROPDOWN_CONFIG, REQUEST_FOR_QUOTATION_ID} from '../../../shared/Config';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import AZNLogo from '../../../assets/images/AZN LOGO .jpg';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import lodash from 'lodash';


const Inputs = ({ field, metaData, onInputChange, type, ...props }) => {
    const Component = ImplementationFor[parseInt(field.fieldType)] || false;

    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        dateFormat={field.dateFormat}
        view={field.view}
        metaData={Object.assign({}, metaData, { "TA Request Number": props.TARequestNumber })}
    /> || null;

};

const currencyList = [
    {"label":"INR","value":"INR","id":"INR"},
    {"label":"KWD","value":"KWD","id":"KWD"},
    {"label":"SAR","value":"SAR","id":"SAR"},
    {"label":"USD","value":"USD","id":"USD"},
    { "label": "AED", "value": "AED", "id": "AED" },
    {"label":"EUR","value":"EUR","id":"EUR"},
    {"label":"OMR","value":"OMR","id":"OMR"},
    {"label":"BHD","value":"BHD","id":"BHD"},
    {"label":"GBP","value":"GBP","id":"GBP"},
    {"label":"CAD","value":"CAD","id":"CAD"},
    {"label":"CHF","value":"CHF","id":"CHF"},
    {"label":"DZD","value":"DZD","id":"DZD"},
    { "label": "IQD", "value": "IQD", "id": "IQD" },
    {"label":"JOD","value":"JOD","id":"JOD"},
    {"label":"PKR","value":"PKR","id":"PKR"},
    {"label":"PHP","value":"PHP","id":"PHP"},   
    { "label": "JPY", "value": "JPY", "id": "JPY" }];


class AddRequestforQuotation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:'',
            month:'',
            year:'',
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            payslipGenerated: false,
            stageSequence: 0,
            month: false,
            year: false,
            requestDate: moment(),
            requestedFor: false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            popupType: 'submit',
            requestattachments:[],
            // Defaults to on so existing behaviour (always send on submit)
            // is unchanged unless the user unchecks it.
            autoSendWhatsApp: true,
            vendorLinksDisplay: false,
            vendorLinks: [],
            purchaseRequestDetails: null,
        }
        this.handleContainer = this.handleContainer.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value } = e.target;

        if (el.fieldDescription === 'Purchase Request Number' && value) {
            this.fetchPurchaseRequestDetails(value);
        }

        const updatedProcess = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => {
            // First pass: update the changed field
            let updatedStageField = stage.stage_Field.map(field =>
                Object.assign({}, { ...field }, { fieldValue: (el.fieldType === '3' && field.fieldName === name) ? value.join(',') : (field.fieldName === name) ? value : field.fieldValue })
            );
            
            // Second pass: check if we need to recalculate Installment Amount
            const changedField = updatedStageField.find(f => f.fieldName === name);
            
            if (changedField && (changedField.fieldDescription === 'Requested Amount' || changedField.fieldDescription === 'Number Of Installments')) {
                // Find all the fields we need
                const requestedAmountField = updatedStageField.find(f => f.fieldDescription === 'Requested Amount');
                const numberOfInstallmentsField = updatedStageField.find(f => f.fieldDescription === 'Number Of Installments');
                const installmentAmountField = updatedStageField.find(f => f.fieldDescription === 'Installment Amount');
                
                // Calculate if all fields exist and have valid values
                if (installmentAmountField && requestedAmountField && numberOfInstallmentsField) {
                    const requestedAmount = requestedAmountField.fieldValue;
                    const numberOfInstallments = numberOfInstallmentsField.fieldValue;
                    
                    if (requestedAmount && numberOfInstallments && numberOfInstallments != 0) {
                        const installmentAmount = (parseFloat(requestedAmount) / parseFloat(numberOfInstallments)).toFixed(2);
                        
                        // Update the installment amount field
                        updatedStageField = updatedStageField.map(field =>
                            field.fieldDescription === 'Installment Amount' ? 
                                Object.assign({}, { ...field }, { fieldValue: installmentAmount }) : 
                                field
                        );
                    }
                }
            }
            
            return Object.assign({}, { ...stage }, { stage_Field: updatedStageField });
        });

        this.setState({
            process: updatedProcess,
            payslipGenerated: false
        });
    }

    // Fires when the "Purchase Request Number" field changes. Fetches the PR
    // and pushes its line items onto this RFQ's item grid.
    fetchPurchaseRequestDetails = (requestId) => {
        axios.get(`/master/api/Employee/GetPRById?RequestId=${requestId}&Company_Id=${this.props.loggedUserDetail.CompanyId}`)
            .then((response) => {
                // Unit id (Uomdesc) -> unit name (Uomname), used for the grid's Unit column
                const prUnitNames = {};
                (response.data || []).forEach(line => {
                    if (line && line.Uomdesc && line.Uomname) prUnitNames[String(line.Uomdesc).trim().toLowerCase()] = line.Uomname;
                });
                this.setState(prev => ({ purchaseRequestDetails: response.data, prUnitNames: Object.assign({}, prev.prUnitNames, prUnitNames) }));
                this.applyPRLinesToContainer(response.data);
            })
            .catch(() => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Failed to fetch Purchase Request details, please try again' });
            });
    }

    // One container field's value taken from a GetPRById line. The dropdown
    // backed fields get the id rather than the display name so they resolve
    // against their master lists — Uomdesc is the UOM id, Uomname is just 'KG'.
    // Item Note has nothing on the PR to carry over, so it stays blank.
    prLineValue = (fieldDescription, line) => {
        switch (fieldDescription) {
            case 'Line Item Number': return line.Lineitemno;
            case 'Material / Service': return line.Serviceeid;
            case 'Quantity': return line.Qty;
            case 'Unit': return line.Uomdesc;
            case 'Unit Price': return line.Unitrate;
            case 'Amount': return line.TaxableAmount;
            default: return null;
        }
    }

    // Puts one PR line onto the container's entry row — the last child row, the
    // one the inputs are bound to — then lets handleContainer commit it and open
    // a fresh blank row, exactly as clicking Add does. handleContainer applies
    // its result on a 3s timeout, so the row has to settle before the next line
    // can be filled in.
    addPRLineRow = (containerField, line) => new Promise(resolve => {
        const stageField = arraySort(this.state.process[0].stage_Field, 'fieldSequence');
        const rowNumbers = Object.keys(lodash.groupBy(stageField.filter(f => f.parentFieldId === containerField.fieldName), 'childRowNmbr'));
        const entryRowNmbr = rowNumbers[rowNumbers.length - 1];

        const process = this.state.process.map((stage, stageIndex) => stageIndex !== 0 ? stage : Object.assign({}, { ...stage }, {
            stage_Field: stage.stage_Field.map(field => (field.parentFieldId === containerField.fieldName && field.childRowNmbr === entryRowNmbr)
                ? Object.assign({}, { ...field }, { fieldValue: this.prLineValue(field.fieldDescription, line) })
                : field)
        }));

        this.setState({ process }, () => {
            this.handleContainer(containerField, true);
            setTimeout(resolve, 3200);
        });
    })

    // Loads the PR's line items into the item container, a row at a time.
    applyPRLinesToContainer = async (prLines) => {
        // The API's trailing all-null line is its own blank entry row, and the
        // container keeps one of those itself, so it isn't added.
        const lines = (prLines || []).filter(line => line && line.Lineitemno);
        if (lines.length === 0) return;

        const stage = this.state.process[0];
        const containerField = stage && arraySort(stage.stage_Field, 'fieldSequence').find(field => field.fieldType === '9');
        if (!containerField) return;

        for (let i = 0; i < lines.length; i++) {
            await this.addPRLineRow(containerField, lines[i]);
        }
    }

    // Finds the dropdown option behind a field value. Compared as lower-cased
    // strings so GUID casing or number-vs-string differences (PR lines vs the
    // master lists) don't leave the raw id showing in the grid.
    findDropdownOption = (fieldDescription, fieldValue) => {
        if (fieldValue === null || fieldValue === undefined || fieldValue === '') return false;
        const target = String(fieldValue).trim().toLowerCase();
        // The PR carries the unit's display name (Uomname) next to its id (Uomdesc)
        if (fieldDescription === 'Unit') {
            const prUnitName = (this.state.prUnitNames || {})[target];
            if (prUnitName) return { label: prUnitName };
        }
        const options = (this.props.metaData && this.props.metaData[fieldDescription]) || [];
        const found = options.find(option => option && [option.value, option.id, option.uniqueId]
            .some(candidate => candidate !== null && candidate !== undefined && String(candidate).trim().toLowerCase() === target));
        if (found) return found;
        // Not in the (possibly stale, localStorage-cached) master list: fall back to
        // the freshly fetched lists this field can draw from.
        if (fieldDescription !== 'Material / Service' && fieldDescription !== 'Unit') return false;
        const label = (this.state.labelFallbacks || {})[target];
        return label ? { label } : false;
    }

    // metaData for one input. A dropdown only shows a selection whose value is
    // strictly one of its options; when editing a row, Material / Service and Unit
    // can hold an id the option list doesn't strictly contain (casing, stale cache,
    // another master), so that id is added as an option carrying its resolved label.
    metaDataFor = (field) => {
        const { metaData = {} } = this.props;
        if (field.fieldDescription !== 'Material / Service' && field.fieldDescription !== 'Unit') return metaData;
        const value = field.fieldValue;
        if (value === null || value === undefined || value === '') return metaData;
        const options = Array.isArray(metaData[field.fieldDescription]) ? metaData[field.fieldDescription] : [];
        if (field.fieldDescription !== 'Unit' && options.some(option => option && option.value === value)) return metaData;
        const resolved = this.findDropdownOption(field.fieldDescription, value);
        if (!resolved) return metaData;
        const rest = options.filter(option => !(option && String(option.value).toLowerCase() === String(value).toLowerCase()));
        return Object.assign({}, metaData, { [field.fieldDescription]: rest.concat({ label: resolved.label, value, id: value }) });
    }

    // The PR can carry a Material / Service id from a different master than the
    // cached dropdown (Ingredient vs MenuItem vs Service), and the cached lists can
    // be out of date. Fetch the underlying lists fresh and index them by id.
    loadLabelFallbacks = () => {
        ['Ingredient', 'MenuItem', 'Service', 'UOM'].forEach(keyword => {
            axios.get(`/master/api/DropDownValues/${keyword}`)
                .then(response => {
                    const additions = {};
                    (response.data || []).forEach(item => {
                        if (!item || !item.text) return;
                        // uniqueId only: the numeric ids collide across the different masters
                        if (item.uniqueId) additions[String(item.uniqueId).trim().toLowerCase()] = item.text;
                    });
                    this.setState(prev => ({ labelFallbacks: Object.assign({}, additions, prev.labelFallbacks) }));
                })
                .catch(() => { /* fallback only; the cached lists still apply */ });
        });
    }

    actionTemplate = (rowData) => {
        return (
            <Button type="button" icon="pi pi-pencil" className="p-button-primary"
                onClick={() => this.startEdit(rowData)} />
        );
    }

    // Reverts any un-updated edits of the row currently being edited back to its snapshot
    restoreEditSnapshot = () => {
        const { editSnapshot, process } = this.state;
        if (!editSnapshot) return process;
        const original = editSnapshot.reduce((o, f) => Object.assign(o, { [f.fieldName]: f.fieldValue }), {});
        return process.map(stage => Object.assign({}, stage, {
            stage_Field: stage.stage_Field.map(f => f.fieldName in original ? Object.assign({}, f, { fieldValue: original[f.fieldName] }) : f)
        }));
    }

    // The DataTable keeps showing the snapshot of the row until Update is clicked
    startEdit = (rowData) => {
        this.setState({
            process: this.restoreEditSnapshot(),
            editing: { parentFieldId: rowData.parentFieldId, childRowNmbr: rowData.childRowNmbr },
            editSnapshot: rowData.stage_Field
        });
    }

    updateEdit = () => {
        const { editing, process } = this.state;
        if (editing) {
            // Validate the fields of the row being edited (current values live in state.process)
            const editedRow = [];
            process.forEach(stage => (stage.stage_Field || []).forEach(f => {
                if (f.parentFieldId === editing.parentFieldId && String(f.childRowNmbr) === String(editing.childRowNmbr)) {
                    editedRow.push(f);
                }
            }));
            const missingFields = [];
            arraySort(editedRow, 'fieldSequence').forEach(el => {
                if (!el.fieldDescription || !ImplementationFor[parseInt(el.fieldType)]) {
                    return;
                }
                const val = el.fieldValue;
                const isEmpty = val === null || val === undefined || (Array.isArray(val) ? val.length === 0 : String(val).trim() === '');
                if (isEmpty && !missingFields.includes(el.fieldDescription)) {
                    missingFields.push(el.fieldDescription);
                }
            });
            if (missingFields.length > 0) {
                this.setState({ requiredFieldsMessage: `Please fill in the following required fields: ${missingFields.join(', ')}.` });
                return;
            }
        }
        this.setState({ editing: false, editSnapshot: null });
    }

    cancelEdit = () => this.setState({ process: this.restoreEditSnapshot(), editing: false, editSnapshot: null });

    rowExpansionTemplate = (data) => {
        try {
            const rowFieldsData = (data.stage_Field || []).map(field => {
                const dropdownValue = this.findDropdownOption(field.fieldDescription, field.fieldValue);
                const value = (dropdownValue && dropdownValue.label) || ((field.fieldType === '7' || field.fieldType === '8') && field.fieldValue && moment(field.fieldValue).format('MM/DD/YYYY')) || field.fieldValue;
                return { label: field.fieldDescription, key: field.fieldName, value };
            });

            const rowsOfThree = rowFieldsData.reduce((rows, fieldItem, index) => {
                const rowIndex = Math.floor(index / 3);
                rows[rowIndex] = rows[rowIndex] || [];
                rows[rowIndex].push(fieldItem);
                return rows;
            }, []);

            return (
                <div className="p-fluid" style={{ padding: '2em 1em 1em 1em' }}>
                    {rowsOfThree.map((rowFields, rowIndex) => (
                        <div
                            key={rowIndex}
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                borderBottom: '1px solid #e0e0e0',
                                padding: '0.75em 0',
                            }}
                        >
                            {rowFields.map(({ label, key, value }, colIndex) => (
                                <div
                                    key={key}
                                    style={{
                                        flex: '1 1 200px',
                                        minWidth: '200px',
                                        padding: '0 1em',
                                        borderRight: colIndex < rowFields.length - 1 ? '1px solid #e0e0e0' : 'none',
                                    }}
                                >
                                    <span>{label}: </span>
                                    <span style={{ fontWeight: 'bold' }}>
                                        {value == null ? '' : value}
                                    </span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            );
        }
        catch (error) {
            this.setState({ error: error })
        }
    }

    setFieldValueUsingFieldId(inputFieldId, process, valueToBeSet) {
        try
        {
        const { stageSequence } = this.state;

        const updatedProcess =  process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldId ? valueToBeSet : field.fieldValue })
                    })
        }))

            return updatedProcess
        }
        catch (error) {
            this.setState({error : error})
         }
    }

    setFieldValueUsingFieldidrownum(inputFieldid, process, valueToBeSet,childRowNmbr) {
        
        try
        {
        const { stageSequence } = this.state;

        const updatedProcess =  process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldid && field.childRowNmbr == childRowNmbr  ? valueToBeSet : field.fieldValue })
                    })
        }))

            return updatedProcess
        }
        catch (error) {
            this.setState({error : error})
         }
    }

    // skipValidation is set by the PR-line import, which fills only the fields the PR carries
    handleContainer = (field, skipValidation = false) => {
        try {
        if (!skipValidation) {
            // Validate the container's input row (the last child row, as rendered) before adding
            const containerStage = this.state.process.find(stage => (stage.stage_Field || []).some(_ => _.fieldName === field.fieldName));
            const containerGroup = containerStage ? lodash.groupBy(containerStage.stage_Field.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr') : {};
            const groupKeys = Object.keys(containerGroup);
            const inputRow = groupKeys.length > 0 ? containerGroup[groupKeys[groupKeys.length - 1]] : [];
            const missingFields = [];
            arraySort(inputRow, 'fieldSequence').forEach(el => {
                if (!el.fieldDescription || !ImplementationFor[parseInt(el.fieldType)]) {
                    return;
                }
                const val = el.fieldValue;
                const isEmpty = val === null || val === undefined || (Array.isArray(val) ? val.length === 0 : String(val).trim() === '');
                if (isEmpty && !missingFields.includes(el.fieldDescription)) {
                    missingFields.push(el.fieldDescription);
                }
            });
            if (missingFields.length > 0) {
                this.setState({ requiredFieldsMessage: `Please fill in the following required fields: ${missingFields.join(', ')}.` });
                return;
            }
        }

        this.setState({ loading: true,ifaddupdatepressed: 1 });
        const { process, stageSequence } = this.state;
        const { location } = this.props;
        let cldr = field.childRowNmbr;
        let flag = 0;
            let vcategory = '';

            let kwdtotalAmount = parseFloat(0.000).toFixed(3);
    
            let dummy = this.state.process.filter((element, index) => index == 0).map((el) => {
                return el.stage_Field.map((el) => {
                    if (el.fieldDescription === 'Description' && (el.fieldValue === "0" || el.fieldValue === "")) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'please enter description' });
                        flag = 1;
                        return;
                    }
                    if (el.fieldDescription === 'Category') {
                        vcategory = el.fieldValue;
                        
                    }
                    if (el.fieldDescription === 'Family Members' && el.fieldValue === null && (vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F14BA' || vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F13BA')) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'Please Select Family Member' });
                        flag = 1;
                        return;
                    }
                    return (el.fieldDescription === 'Amount in KWD') && el || null;
                }).filter(el => el != null).map(el => Object.assign({}, {
                    amount: parseFloat( el.fieldValue)
                }));
            });

            if (flag === 1) return;

            let totalAmount = parseFloat(0.000);
            let j;
            for (j = 0; j < dummy[0].length; j++) {
                totalAmount += parseFloat(dummy[0][j].amount)
            }

            let error = 0;
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                if (stageIndex === 0) {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    const containerGroup = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || [];
                    const fields = containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1] || [];
                    if (fields && fields.length > 0) {
                        let count = stageField.length + 1;
                        let sequence = stageField.length + 1;
                        const newFields = fields.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, 10);
                            a.push(Object.assign({}, { ...el }, {
                                fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: field.fieldName, childRowNmbr: Object.keys(containerGroup).length.toString(), fieldValue: (el.fieldType == 1) ? ((field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount : (el.fieldDescription == 'Hotel Expense') ? 0 :
                                    (el.fieldDescription == 'Transportation Expense') ? 0 : (el.fieldDescription == 'Meals Expense') ? 0 : (el.fieldDescription == 'Purchases Expense') ? 0 : (el.fieldDescription == 'Other Expenses') ? 0 : '') : (el.fieldDescription == 'Exchange Rate') ? 0 : null
                            }));
                            return a;
                        }, []);
                        return Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.concat(newFields) });
                    } else if (location && location.state && location.state.stagesequence === stageIndex) {
                        error = 1;
                        return stage;
                    }
                    else {
                        return stage;
                    }
                } else {
                    return stage;
                }
            });
            j = 0;
        
           //  const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldId("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount)

            const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldidrownum("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount, cldr)




            setTimeout(() => {
                try
                {

                    if (error) {
                        this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
                        return;
                    }
                  
                     this.setState({ loading: false, process: initialValuesWithUpdatedTotal });
                   
                    //this.setState({ loading: false });
                //this.setState({ loading: false, process: InitialValues });
                //this.setState({ loading: false }, { process: process });

                }

                catch (error)
                {
                    //handleExpectedError(error);
                    this.setState({ error: error });
                } 
            
            }, 3000);

        }

        catch (error)
        {
            //handleExpectedError(error);
            this.setState({ error: error });
        }
       
        //i = 0;

        // this.setState({
        //     process: this.state.process.filter((p,i) => i <= 20  ).map(stage => Object.assign({}, { ...stage }, {
        //         stage_Field: stage
        //             .stage_Field.map(field => {
        //                 return Object.assign({}, { ...field }, { fieldValue:  field.fieldDescription === 'Total Amount in KWD' && totalAmount ? totalAmount  : field.fieldValue })
        //             })
        //     }))
        // });

   
        // this.setState({
        //     process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue:  (field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount: field.fieldValue })) }))
        // });
    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return{
                Requestattachmentid: '00000000-0000-0000-0000-000000000000' ,
                Requestid :'00000000-0000-0000-0000-000000000000',
                SiNo: index ,
                UploadPath:el.filePath ,
                FileName:el.fileName ,
                Extension :el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID ,
                Createddate: moment().format('MM/DD/YYYY') ,
                Updatedby: this.props.loggedUserDetail.empID ,
                Updateddate: moment().format('MM/DD/YYYY') ,
                CompanyId: this.props.loggedUserDetail.CompanyId ,
                Stagenum: 0 ,
            }
        });
        this.setState({requestattachments:attachmentData});
    }

    initialize = (process, type, field) => {
        const { tableLists, location = {}} = this.props;
        const { stageSequence } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;         
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith


        let count = 1;
        let sequence = 1;
        if (type === 'progress' || type === 'add' || type === 'edit') {
            this.setState({ process: [], loading: true });

            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (type === 'add' && el.parentFieldId === '000' && el.fieldType != '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        } else if (type === 'add' && el.fieldType === '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const fields = stageField.filter(_ => _.parentFieldId === el.fieldName);
                            const lastItem = a[a.length - 1];
                            fields.map((subField) => {
                                a.push(Object.assign({}, { ...subField }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName, childRowNmbr: '0' }));
                            })
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const lastItem = a[a.length - 1];
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName }));
                                        })
                                    }
                                })
                            }
                        }
                        return a;
                    }, [])
                })
            });

            setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
        } else {

            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

    }


    // Resolves ID/value to its corresponding Label for PDF display (same pattern as JournalVoucher).
    resolveFieldDisplayValue = (field) => {
        const { metaData = {} } = this.props;

        if (!field) {
            return '';
        }

        const fieldValue = field.fieldValue;

        if (fieldValue == null || fieldValue === '') {
            return '';
        }

        const options = metaData[field.fieldDescription] || [];

        const matchedOption = options.find(option => {
            if (!option) return false;
            return (
                String(option.value != null ? option.value : '').toLowerCase() === String(fieldValue).toLowerCase() ||
                String(option.id != null ? option.id : '').toLowerCase() === String(fieldValue).toLowerCase() ||
                String(option.uniqueId != null ? option.uniqueId : '').toLowerCase() === String(fieldValue).toLowerCase()
            );
        });

        if (matchedOption) {
            return matchedOption.label || matchedOption.text || matchedOption.name || fieldValue;
        }

        if (field.fieldType === '7' || field.fieldType === '8') {
            return moment(fieldValue).format('DD/MM/YYYY');
        }

        return fieldValue;
    };

    // Resolves an Employee ID to its Employee label/name for PDF display (same pattern as JournalVoucher).
    resolveEmployeeLabel = (employeeId) => {
        if (employeeId == null || employeeId === '') {
            return '';
        }

        const { metaData = {}, EmployeeList = [] } = this.props;

        const employeeOptions = [
            ...(metaData['Requested For'] || []),
            ...(EmployeeList || [])
        ];

        const employee = employeeOptions.find(option => {
            if (!option) return false;
            return (
                String(option.value || '').toLowerCase() === String(employeeId).toLowerCase() ||
                String(option.id || '').toLowerCase() === String(employeeId).toLowerCase() ||
                String(option.uniqueId || '').toLowerCase() === String(employeeId).toLowerCase()
            );
        });

        return employee
            ? (employee.label || employee.text || employee.name || employee.userName || employee.employeeName || employeeId)
            : employeeId;
    };

    // Resolves the "Vendors to Send RFQ" field's comma-separated Vendor IDs to their
    // Vendor Label/Name(s) for PDF display, same lookup convention as resolveFieldDisplayValue
    // but handling multiple selected IDs instead of a single value.
    resolveVendorLabels = (fieldValue) => {
        if (fieldValue == null || fieldValue === '') {
            return '';
        }

        const { metaData = {} } = this.props;
        const options = metaData['Vendors to Send RFQ'] || [];

        return fieldValue.split(',').map(id => id.trim()).filter(id => id).map(id => {
            const matchedOption = options.find(option => {
                if (!option) return false;
                return (
                    String(option.value != null ? option.value : '').toLowerCase() === id.toLowerCase() ||
                    String(option.id != null ? option.id : '').toLowerCase() === id.toLowerCase() ||
                    String(option.uniqueId != null ? option.uniqueId : '').toLowerCase() === id.toLowerCase()
                );
            });
            return matchedOption ? (matchedOption.label || matchedOption.text || matchedOption.name || id) : id;
        }).join(', ');
    };

    generatePayslip = (type) => {
        this.setState({ loading: true });
        this.handlePayslipInPdf(type);
    }

    handlePayslipInPdf = (type) => {
        try {
            const { process } = this.state;
            const { location = {}, tableLists = {}, loggedUserDetail = {}, containerData } = this.props;
            const { state = {} } = location;

            // Full stage list (reached stages + any stages not yet reached/approved), same
            // concat convention used elsewhere, so pending stages are included instead of
            // being structurally absent from `process`.
            const templateStages = (containerData && Object.keys(containerData).length > 0 && containerData.stage) || [];
            const fullProcess = (process.length > 0 && process.concat(templateStages.filter((c, i) => i > (process.length - 1)))) || process;

            // Header fields: top-level (non-container) fields across every completed stage
            const headerFields = process.reduce((fields, stage) => {
                return fields.concat((stage.stage_Field || []).filter(field => field.parentFieldId === '000' && field.fieldType !== '9'));
            }, []);

            // Line items: fieldType '9' containers, grouped by childRowNmbr (same grouping used on-screen), excluding the trailing in-progress row
            let lineItemColumns = [];
            let lineItemRows = [];
            process.forEach(stage => {
                (stage.stage_Field || []).filter(field => field.fieldType === '9').forEach(containerField => {
                    const groupFields = (stage.stage_Field || []).filter(field => field.parentFieldId === containerField.fieldName);
                    const grouped = lodash.groupBy(groupFields, 'childRowNmbr');
                    const rowKeys = Object.keys(grouped);
                    const committedRowKeys = rowKeys.filter((key, i) => i !== rowKeys.length - 1);
                    if (committedRowKeys.length === 0) { return; }

                    const columnFields = grouped[rowKeys[rowKeys.length - 1]] || grouped[committedRowKeys[0]] || [];
                    if (lineItemColumns.length === 0) {
                        lineItemColumns = columnFields.map(field => field.fieldDescription);
                    }

                    committedRowKeys.forEach(key => {
                        const row = grouped[key];
                        lineItemRows.push(columnFields.map(colField => {
                            const match = row.find(r => r.fieldDescription === colField.fieldDescription);
                            return match ? this.resolveFieldDisplayValue(match) : '';
                        }));
                    });
                });
            });

            const requestNum = state.requestNum || (tableLists && tableLists.requestNum) || 'RequestforQuotation';

            // Requested For: convert Employee ID to Employee Label/Name.
            const requestedForField = headerFields.find(
                field =>
                    field.fieldDescription === 'Requested For' ||
                    field.fieldDescription === 'Request For'
            );

            const requestedFor = requestedForField
                ? this.resolveEmployeeLabel(requestedForField.fieldValue)
                : '';

            // Created By must always match the Requested For name shown elsewhere in the PDF.
            const createdBy = requestedFor;

            const printedBy = (loggedUserDetail && (loggedUserDetail.userName || loggedUserDetail.empID)) || '';
            const printedOn = moment().format('DD/MM/YYYY HH:mm');

            // Request Details laid out as one row (Request Num + every header field), same structure as Line Items
            const headerColumns = ['Request Num', ...headerFields.map(field => field.fieldDescription)];

            const headerValues = [
                requestNum,
                ...headerFields.map(field => {
                    if (
                        field.fieldDescription === 'Request For' ||
                        field.fieldDescription === 'Requested For'
                    ) {
                        return this.resolveEmployeeLabel(field.fieldValue);
                    }

                    if (field.fieldDescription === 'Vendors to Send RFQ') {
                        return this.resolveVendorLabels(field.fieldValue);
                    }

                    return this.resolveFieldDisplayValue(field);
                })
            ];

            var doc = new jsPDF('p', 'mm', 'a4', 3);

            doc.autoTable({
                theme: 'plain',
                didDrawCell: function (data) {
                    if (data.column.index === 0 && data.cell.section === 'body') {
                        try {
                            doc.addImage(chenthoorLandscapeLogo, 'PNG', data.cell.x, data.cell.y - 3, 40, 20);
                        } catch (logoError) {
                            // Continue without the logo rather than failing the whole PDF.
                        }
                    }
                },
                startY: 9,
                margin: { left: 8.5 },
                columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 200 } },
                body: [[
                    { content: "", styles: { cellPadding: 0, borderColor: 'white' } },
                    { content: "CHENTHOOR RESTAURANT", styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fontSize: 14, textColor: 'black', cellPadding: { top: 5, left: 6, right: 0 }, borderColor: 'white' } }
                ]]
            });

            let previousTableEnding = doc.lastAutoTable.finalY;

            doc.setFontSize(12);
            doc.text('Request Details:', 5, previousTableEnding + 14);

            // Split Request Details across two rows: first half of fields, then the remaining half
            const headerMidpoint = Math.ceil(headerColumns.length / 2);
            const headerColumnsRow1 = headerColumns.slice(0, headerMidpoint);
            const headerValuesRow1 = headerValues.slice(0, headerMidpoint);
            const headerColumnsRow2 = headerColumns.slice(headerMidpoint);
            const headerValuesRow2 = headerValues.slice(headerMidpoint);

            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 18,
                styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                alternateRowStyles: { fillColor: [255, 255, 255] },
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0.1,
                margin: { left: 5 },
                tableWidth: 200,
                head: [headerColumnsRow1],
                body: [headerValuesRow1],
            });

            previousTableEnding = doc.lastAutoTable.finalY;

            if (headerColumnsRow2.length > 0) {
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [headerColumnsRow2],
                    body: [headerValuesRow2],
                });

                previousTableEnding = doc.lastAutoTable.finalY;
            }

            if (lineItemRows.length > 0) {
                doc.setFontSize(12);
                doc.text('Line Items:', 5, previousTableEnding + 14);
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 18,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [lineItemColumns],
                    body: lineItemRows,
                });
                previousTableEnding = doc.lastAutoTable.finalY;
            }

            // Approval History: parsed from each subsequent stage's description (skips the initial/request stage),
            // same extraction logic used elsewhere (e.g. Wastage) so approval-history PDF sections stay consistent.
            const processArray = fullProcess.slice(1);
            const approvalHistoryRows = [];
            let approvalIndex = 0;
            processArray.forEach(item => {
                const hasApprovalDetails = item.description && item.description.includes(',');

                let employeeNumber = '';
                let employeeName = '';
                let position = '';
                let dateAndTime = 'Pending';

                // Employee Number/Name/Position are populated from the description whenever it's
                // parseable, whether or not this particular stage has been approved yet.
                if (hasApprovalDetails) {
                    const parts = item.description.split(',').map(part => part.trim());
                    // Strip whatever label precedes the colon (e.g. "Released By:", "Requested By:", "Approved By:")
                    // instead of only matching one exact wording, so this works consistently across every stage.
                    employeeNumber = (parts[0] || '').replace(/^[^:]+:\s*/, '').trim();
                    employeeName = ((parts[1] || '').split('-')[0] || '').trim();
                    position = (parts[2] || '').trim();

                    // A stage is actually approved once its date segment carries a real value
                    // (not just its label). This reflects each stage's own saved data
                    // independently, rather than relying on the workflow's current stageSequence.
                    const parsedDateAndTime = (parts[3] || '').replace(/^[^:]+:\s*/, '').trim();
                    if (parsedDateAndTime) {
                        dateAndTime = parsedDateAndTime;
                    }
                }

                approvalHistoryRows.push([
                    approvalIndex + 1,
                    employeeNumber,
                    employeeName,
                    position,
                    dateAndTime
                ]);
                approvalIndex++;
            });

            if (approvalHistoryRows.length > 0) {
                doc.setFontSize(12);
                doc.text('Approval History:', 5, previousTableEnding + 14);
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 18,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [['S.No', 'Employee Number', 'Employee Name', 'Position', 'Date & Time']],
                    body: approvalHistoryRows,
                });
                previousTableEnding = doc.lastAutoTable.finalY;
            }

            // Footer (Created By / Printed By / Printed On) on every page.
            const totalPages = doc.internal.getNumberOfPages();
            for (let pageIndex = 1; pageIndex <= totalPages; pageIndex++) {
                doc.setPage(pageIndex);
                doc.setFontSize(8);
                doc.setTextColor(0, 0, 0);
                doc.text(`Created By: ${createdBy}     Printed By: ${printedBy}     Printed On: ${printedOn}`, 5, 292);
            }

            if (type === 'print') {
                doc.autoPrint();
                window.open(doc.output('bloburl'), requestNum);
                this.setState({ loading: false, payslipGenerated: true });
            } else if (type === 'view') {
                window.open(doc.output('bloburl'), requestNum);
                this.setState({ loading: false, payslipGenerated: true });
            } else if (type === 'download') {
                doc.save(`${requestNum}.pdf`);
                this.setState({ loading: false, payslipGenerated: true });
            }
        } catch (error) {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'Failed to generate PDF' });
        }
    }

    getSelectedVendorIds = () => {
        let selected = [];
        (this.state.process || []).forEach(stage => {
            (stage.stage_Field || []).forEach(field => {
                if (field.fieldDescription === 'Vendors to Send RFQ' && field.fieldValue) {
                    selected = field.fieldValue.split(',').map(v => v.trim()).filter(v => v);
                }
            });
        });
        return selected;
    }

    extractRFQLineItems = () => {
        let columns = [];
        let rows = [];

        (this.state.process || []).forEach(stage => {
            const stageField = arraySort(stage.stage_Field, 'fieldSequence');
            stageField.forEach(field => {
                if (field.fieldType === '9') {
                    const containerGroup = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr'));
                    const groupKeys = Object.keys(containerGroup);
                    if (groupKeys.length > 0) {
                        const lastKey = groupKeys[groupKeys.length - 1];
                        columns = containerGroup[lastKey].map(f => f.fieldDescription);
                        rows = groupKeys.filter((g, i) => i !== groupKeys.length - 1).map(key =>
                            containerGroup[key].reduce((acc, c) => {
                                const dropdownValues = this.findDropdownOption(c.fieldDescription, c.fieldValue);
                                acc[c.fieldDescription] = (dropdownValues && dropdownValues.label) || ((c.fieldType === '7' || c.fieldType === '8') && c.fieldValue && moment(c.fieldValue).format('MM/DD/YYYY')) || c.fieldValue || '';
                                return acc;
                            }, {})
                        );
                    }
                }
            });
        });

        return { columns, rows };
    }

    generateRFQImage = (vendorName, requestNumber, lineItems) => {
        const { columns, rows } = lineItems;
        const width = 900;
        const rowHeight = 26;
        const headerHeight = 160;
        const tableHeaderHeight = 30;
        const height = headerHeight + tableHeaderHeight + (Math.max(rows.length, 1) * rowHeight) + 40;

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);
        ctx.strokeStyle = '#000000';
        ctx.fillStyle = '#000000';
        ctx.lineWidth = 1;

        ctx.textAlign = 'center';
        ctx.font = 'bold 16px Arial';
        ctx.fillText('REQUEST FOR QUOTATIONS', width / 2, 30);
        ctx.font = '10px Arial';
        ctx.fillText('(THIS IS NOT AN ORDER)', width / 2, 46);

        ctx.strokeRect(20, 60, width - 40, 80);
        ctx.beginPath();
        ctx.moveTo(width / 2, 60);
        ctx.lineTo(width / 2, 140);
        ctx.moveTo(20, 100);
        ctx.lineTo(width - 20, 100);
        ctx.stroke();

        ctx.textAlign = 'left';
        ctx.font = '9px Arial';
        ctx.fillText('REQUEST NUMBER', 26, 70);
        ctx.font = '12px Arial';
        ctx.fillText(requestNumber || '', 26, 90);

        ctx.font = '9px Arial';
        ctx.fillText('DATE ISSUED', width / 2 + 6, 70);
        ctx.font = '12px Arial';
        ctx.fillText(moment().format('MM/DD/YYYY'), width / 2 + 6, 90);

        ctx.font = '9px Arial';
        ctx.fillText('TO', 26, 110);
        ctx.font = '12px Arial';
        ctx.fillText(vendorName || '', 26, 130);

        let tableY = headerHeight;
        ctx.font = 'bold 11px Arial';
        ctx.fillText('SCHEDULE', 20, tableY - 6);

        const colCount = Math.max(columns.length, 1);
        const colWidth = (width - 40) / colCount;
        const tableHeight = tableHeaderHeight + (Math.max(rows.length, 1) * rowHeight);
        ctx.strokeRect(20, tableY, width - 40, tableHeight);

        ctx.font = 'bold 10px Arial';
        ctx.textAlign = 'center';
        columns.forEach((col, i) => {
            const x = 20 + i * colWidth;
            ctx.strokeRect(x, tableY, colWidth, tableHeaderHeight);
            ctx.fillText(col, x + colWidth / 2, tableY + 19, colWidth - 6);
        });

        ctx.font = '10px Arial';
        rows.forEach((row, r) => {
            const y = tableY + tableHeaderHeight + r * rowHeight;
            columns.forEach((col, i) => {
                const x = 20 + i * colWidth;
                ctx.strokeRect(x, y, colWidth, rowHeight);
                const value = row[col] !== undefined && row[col] !== null ? String(row[col]) : '';
                ctx.fillText(value, x + colWidth / 2, y + rowHeight / 2 + 4, colWidth - 6);
            });
        });

        return canvas.toDataURL('image/png').split(',')[1];
    }

    // https://chenthoor.hrapprova.com/supplierquotation/add/new/{vendorId}/{rfqId}
    // 'add'/'new' are fixed; the vendor and RFQ (requestId) fill the last two segments.
    buildSupplierQuotationLink = (vendorId, rfqId) =>
        `https://chenthoor.hrapprova.com/add-supplierquotation/add/new/${vendorId}/${rfqId}`;

    // Resolves the selected vendors for this RFQ into send-ready records (name,
    // phone, the supplier-quotation link). Shared by the auto-send-on-submit
    // path and the manual per-vendor send panel so both work off the same data.
    resolveRFQVendors = async (requestNumber, requestId) => {
        const selectedVendorIds = this.getSelectedVendorIds();
        if (selectedVendorIds.length === 0) return [];

        const response = await axios.get('/master/api/Employee/GetVendorList');
        const vendors = (response.data || []).filter(v => selectedVendorIds.includes((v.vendorId || '').toString()));
        const lineItems = this.extractRFQLineItems();

        return vendors.map(vendor => ({
            vendorId: vendor.vendorId,
            vendorName: vendor.vendorName || 'Vendor',
            phone: vendor.contactnumberprocurement || vendor.contactnumbertimesheet || vendor.contactnumberbilling || '',
            link: this.buildSupplierQuotationLink(vendor.vendorId, requestId),
            lineItems,
            requestNumber,
            sending: false,
            sent: false,
            error: null,
        }));
    };

    // Sends one vendor's WhatsApp message: the 'quotation_request' template,
    // with the clickable supplier-quotation link in param1 (customerName) —
    // not the vendor's name.
    sendVendorWhatsApp = (vendor) => {
        if (!vendor.phone) return Promise.reject(new Error('No phone number on file'));

        const base64Image = this.generateRFQImage(vendor.vendorName, vendor.requestNumber, vendor.lineItems);

        return axios.post('https://hussainiya.hrapprova.com/api/send-document', {
            pdf: base64Image,
            fileName: `RFQ-${vendor.requestNumber}.png`,
            to: vendor.phone,
            customerName: vendor.link,
            templateName: 'quotation_request',
        }, {
            headers: { 'x-api-key': 'chenthoor@2026apikey' }
        });
    };

    // axios's err.message on an HTTP error is just "Request failed with
    // status code 400" — the actual reason the API rejected the payload is
    // in the response body, which this pulls out for logging/display instead
    // of letting it get thrown away.
    describeWhatsAppError = (err) => {
        const body = err.response && err.response.data;
        if (body) {
            return typeof body === 'string' ? body : (body.message || body.error || JSON.stringify(body));
        }
        return err.message || 'Send failed';
    };

    sendRFQViaWhatsApp = async (vendors) => {
        const results = await Promise.allSettled(vendors.map(vendor => this.sendVendorWhatsApp(vendor)));
        results.forEach((result, i) => {
            if (result.status === 'rejected') {
                console.error(`RFQ WhatsApp send error for ${vendors[i].vendorName}:`, this.describeWhatsAppError(result.reason), result.reason);
            }
        });
    }

    // Manual per-vendor send from the post-submit panel (autoSendWhatsApp off).
    handleManualVendorSend = async (vendorId) => {
        const vendor = this.state.vendorLinks.find(v => v.vendorId === vendorId);
        if (!vendor) return;

        this.setState(prev => ({
            vendorLinks: prev.vendorLinks.map(v => v.vendorId === vendorId ? { ...v, sending: true, error: null } : v)
        }));

        try {
            await this.sendVendorWhatsApp(vendor);
            this.setState(prev => ({
                vendorLinks: prev.vendorLinks.map(v => v.vendorId === vendorId ? { ...v, sending: false, sent: true } : v)
            }));
        } catch (err) {
            const detail = this.describeWhatsAppError(err);
            console.error('Manual RFQ WhatsApp send error:', detail, err);
            this.setState(prev => ({
                vendorLinks: prev.vendorLinks.map(v => v.vendorId === vendorId ? { ...v, sending: false, error: detail } : v)
            }));
        }
    };

    handleFinishVendorLinks = () => {
        this.setState({ vendorLinksDisplay: false });
        this.props.history.push('/dashboard');
    };

    // Manual re-open of the send panel for an already-submitted RFQ — reuses
    // resolveRFQVendors/the same vendorLinks dialog as the submit flow, so a
    // user can resend (e.g. after a failed send, or to notify a vendor again)
    // without re-submitting the RFQ. Edit mode only, since it needs a saved requestId.
    handleResendWhatsApp = async () => {
        const requestNumber = (this.props.location && this.props.location.state && this.props.location.state.requestNum) || '';
        const requestId = this.state.requestId || this.props.match.params.id;
        if (!requestId) return;

        this.setState({ loading: true });
        const vendors = await this.resolveRFQVendors(requestNumber, requestId);
        this.setState({ loading: false });

        if (vendors.length === 0) {
            this.growl.show({ severity: 'error', summary: null, detail: 'No vendors are selected on this RFQ to resend to' });
            return;
        }
        this.setState({ vendorLinks: vendors, vendorLinksDisplay: true });
    };

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process } = this.state;
        const type = this.props.match.params.type;
        let requestNumber = (this.props.location && this.props.location.state && this.props.location.state.requestNum) || '';
        let loggedUserEmpId = this.props.loggedUserDetail.empID;


        let RequestAttributes = [];
        let Comment = '';
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {

                if (el.fieldDescription === 'Remarks' && el.parentFieldId === '000' && stageIndex === 0 ) {
                    Comment = el.fieldValue;
                }
        //         if(el.fieldDescription === 'Expense Type' && stageIndex === 0){
        //             RequestType = el.fieldValue;
        //         }

                RequestAttributes.push(Object.assign({}, { ...el }, { fieldValue: (el.fieldType === "7" || el.fieldType === "8") ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue }));
            })
        });

        // Required-field validation on Save/Submit, same approach as SalesOrder
        if (submitType === 'save' || submitType === 'submit') {
            const missingFields = [];
            // Only stages shown on screen (same filter the render uses)
            process.filter((p, i) => i <= parseInt(this.state.stageSequence)).forEach(stage => {
                (stage.stage_Field || []).forEach(el => {
                    if (el.fieldStatus !== 'Required' || el.parentFieldId !== '000' || el.fieldType === '9') {
                        return;
                    }
                    // Only validate fields that are actually rendered on the form (same check Inputs uses)
                    if (!el.fieldDescription || !ImplementationFor[parseInt(el.fieldType)]) {
                        return;
                    }
                    const val = el.fieldValue;
                    const isEmpty = val === null || val === undefined || (Array.isArray(val) ? val.length === 0 : String(val).trim() === '');
                    if (isEmpty && !missingFields.includes(el.fieldDescription)) {
                        missingFields.push(el.fieldDescription);
                    }
                });
            });
            // Containers without at least one saved row (the last child row is the input row, not a saved one)
            const emptyContainers = [];
            process.filter((p, i) => i <= parseInt(this.state.stageSequence)).forEach(stage => {
                (stage.stage_Field || []).filter(el => el.fieldType === '9' && el.parentFieldId === '000').forEach(container => {
                    const grouped = lodash.groupBy((stage.stage_Field || []).filter(_ => _.parentFieldId === container.fieldName), 'childRowNmbr');
                    const rowKeys = Object.keys(grouped);
                    if (rowKeys.length === 0 || rowKeys.length > 1) {
                        return;
                    }
                    const requiredNames = [];
                    arraySort(grouped[rowKeys[0]], 'fieldSequence').forEach(sub => {
                        if (sub.fieldStatus !== 'Required' || !sub.fieldDescription || !ImplementationFor[parseInt(sub.fieldType)]) {
                            return;
                        }
                        if (!requiredNames.includes(sub.fieldDescription)) {
                            requiredNames.push(sub.fieldDescription);
                        }
                    });
                    if (requiredNames.length > 0) {
                        emptyContainers.push({ name: container.fieldDescription, fields: requiredNames });
                    }
                });
            });

            if (missingFields.length > 0 || emptyContainers.length > 0) {
                const lines = [];
                if (missingFields.length > 0) {
                    lines.push(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
                }
                if (emptyContainers.length > 0) {
                    lines.push('Please add at least one row with the following required fields in each container:');
                }
                this.setState({ requiredFieldsMessage: lines.join('\n'), requiredFieldsContainers: emptyContainers });
                return;
            }
        }

        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Request For Quotation',
            IsActive: true,
            RequestDate: moment().format('MM/DD/YYYY'),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: REQUEST_FOR_QUOTATION_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'RFQ';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'RFQ';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'RFQ';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
                model = 'RFQ';
            }


            if ( type === 'edit' && this.state.requestId) {
                data.requestId = this.state.requestId
            }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });

            // if(requestNumber && submitType == 'submit'){//checking whether the request is in the requester stage or approver stage
            //     let generatedPdf = this.handlePayslipInPdf('upload', loggedUserEmpId.toUpperCase());
            //     axios.post(`/master/api/Base4ToPDF`, generatedPdf)
            //         .then(response => {
            //             if(response.status == 200){
            //                 axios.post(url, JSON.stringify(datas))// triggering the submit/save of a request
            //                     .then(response => {
            //                         this.setState({ loading: false });
            //                         if (submitType === 'submit' || submitType === 'return') {
            //                             if (response.status === 200) {
            //                                 if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
            //                                     let submitValue = response.data.result && JSON.parse(response.data.result);
            //                                     let tableValue = [];
            //                                     if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
            //                                         tableValue = submitValue.Table.map(list => {
            //                                             return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
            //                                         })
            //                                     }
            //                                     if(submitType === 'submit'){
            //                                         this.setState({dialogBoxText: "Select Supervisor"})
            //                                     }
            //                                     if(submitType === 'return'){
            //                                         this.setState({dialogBoxText: "Return To", popupType:'return'})
            //                                     }
            //                                     this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
            //                                 } else {
            //                                     this.growl.show({ severity: 'success', summary: null, detail: 'Visitor Gate-Pass Request submitted successfully' });
            //                                     this.props.history.push('/dashboard');
            //                                 }
            //                             } else {
            //                                 this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                             }

            //                         } else {
            //                             this.growl.show({ severity: 'success', summary: null, detail: 'Visitor Gate-Pass Request saved successfully' });
            //                             this.props.history.push('/dashboard');
            //                         }

            //                     })
            //                     .catch(err => {
            //                         this.setState({ loading: false })
            //                         this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                     })
            //             }
    
            //         }).catch(err => {
            //             this.growl.show({ severity: 'error', summary: null, detail: 'File Upload API Failed. Please Approve again' });
            //             this.setState({ loading: false });
            //         })
            // } else 
                {
                axios.post(url, JSON.stringify(datas))
                .then(response => {

                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
                                    })
                                }
                                if(submitType === 'submit'){
                                    this.setState({dialogBoxText: "Select Supervisor"})
                                }
                                if(submitType === 'return'){
                                    this.setState({dialogBoxText: "Return To", popupType:'return'})
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'RequestForQuotation Request submitted successfully' });
                                if (submitType === 'submit') {
                                    const finalRequestId = response.data.reqId || this.state.requestId;
                                    this.resolveRFQVendors(requestNumber, finalRequestId).then(vendors => {
                                        if (vendors.length === 0) {
                                            this.props.history.push('/dashboard');
                                            return;
                                        }
                                        if (this.state.autoSendWhatsApp) {
                                            // Keep the loader up and hold the redirect until
                                            // send-document has actually responded for every
                                            // vendor, instead of firing it and navigating away
                                            // immediately.
                                            this.setState({ loading: true });
                                            this.sendRFQViaWhatsApp(vendors).then(() => {
                                                this.setState({ loading: false });
                                                this.props.history.push('/dashboard');
                                            });
                                        } else {
                                            // Hold on this page so the user can review and
                                            // manually send each vendor's link instead.
                                            this.setState({ requestId: finalRequestId, vendorLinks: vendors, vendorLinksDisplay: true });
                                        }
                                    });
                                } else {
                                    this.props.history.push('/dashboard');
                                }
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'RequestForQuotation  Request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                })
            }

        }

    }

    componentDidMount() {
        const { getContainerData, getKeywordValues, getMasterKeywordList, location = {}, loggedUserDetail } = this.props;
        const type = this.props.match.params.type;
        // this.effectiveDateHandler()
        // getContainerData("B1F0B0EC-DF1D-414B-BD09-9AED7F0BA1BB");//Get Container Data
        getMasterKeywordList("Employee");
        getMasterKeywordList("Ingredient");
        getMasterKeywordList("UOM");
        getMasterKeywordList("Vendor");
        getMasterKeywordList("PR");
        this.loadLabelFallbacks();
        if (type === 'add') {
        getContainerData(REQUEST_FOR_QUOTATION_ID);//Get Container Data
        }
        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({requestattachments});

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
            }

            if (process && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                clearTimer();
            }
        }, 300);

    }


    render() {
        const { tableLists, location = {} } = this.props;
        const { state = {} } = location;
        const { process, stageSequence, currentSequence, editing, editSnapshot } = this.state;
        const pendingWith = location && location.state && location.state.pendingWith;
        const actionRowStyle = { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' };

        const pageType = this.props.match.params.type;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;  
        const dialogDynamicFooter = (
            <div style={actionRowStyle}>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary" />
            </div>
        );
        let a;
        {
            a = process.filter((p, i) => i <= parseInt(stageSequence));
       }


        return (
            
            <div className="p-grid leaverequest">
                           {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                           {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                           <Toast ref={(el) => this.growl = el} />
                           <div className="p-col-12">
                               <div className="card card-w-title" style={{ position: 'relative' }}>
                                   <h1>
                                   Request For Quotation
                                       <Link to={'/requestforquotation'}>
                                          <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                                       </Link>
                                   </h1>
                                   <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                               </div>
                           </div>
                

                
                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage,  stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    const containerGroup = field.fieldType === '9' && lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || false;
                                    const containerFields = (containerGroup && Object.keys(containerGroup).length > 0 && editing && editing.parentFieldId === field.fieldName && containerGroup[editing.childRowNmbr]) || (containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1]) || [];
                                    const containerTable = containerGroup && Object.keys(containerGroup).length > 0 && Object.keys(containerGroup).filter((g, i) => i != Object.keys(containerGroup).length - 1).reduce((tableRow, row) => {
                                        const displayFields = (editing && editSnapshot && editing.parentFieldId === field.fieldName && String(editing.childRowNmbr) === String(row)) ? editSnapshot : containerGroup[row];
                                        const rowFields = displayFields.reduce((r, c) => {
                                            const DropdownValues = this.findDropdownOption(c.fieldDescription, c.fieldValue);
                                            return Object.assign({}, { ...r }, { [c.fieldDescription.replaceAll(' ', '_')]: (DropdownValues && DropdownValues.label) || ((c.fieldType === '7' || c.fieldType === '8') && moment(c.fieldValue).format('MM/DD/YYYY')) || c.fieldValue, childRowNmbr: c.childRowNmbr, parentFieldId: c.parentFieldId })
                                        }, {});
                                        // stage_Field carries the row's raw fields for rowExpansionTemplate
                                        tableRow.push(Object.assign({}, rowFields, { stage_Field: displayFields }));
                                        return tableRow;
                                    }, []) || [];
                                   
                                    return field.parentFieldId === "000" ? <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldType != "9" ? <Inputs
                                            field={Object.assign({}, {...field}, {disabled: field.fieldDescription === 'Installment Amount' ? true : field.disabled, dateFormat: (field.fieldDescription === 'Repayment Start Month' || field.fieldDescription === 'Repayment End Month') ? 'mm/yy' : undefined, view: (field.fieldDescription === 'Repayment Start Month' || field.fieldDescription === 'Repayment End Month') ? 'month' : undefined})}
                                            value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(",") : field.fieldValue}
                                            process={process}
                                            onInputChange={(e) => this.handleChange(e, field)}
                                            {...this.props}
                                            {...this.state} /> :
                                            field.fieldType === '9' ?
                                                <Fieldset legend={field.fieldDescription} toggleable collapsed={this.state[field.fieldName] === undefined ? true : this.state[field.fieldName]} onToggle={(e) => this.setState({[field.fieldName]: e.value})} style={{border: this.state[field.fieldName] === undefined || this.state[field.fieldName] ? 'none' : '1px solid rgba(0, 0, 0, 0.38)'}}>
                                                    <div className="p-grid">
                                                        {containerFields.map((subField, subIndex) => <div key={subIndex} className={"p-col-12 p-md-6 p-lg-4"}><Inputs
                                                            field={Object.assign({}, {...subField}, {disabled: subField.fieldDescription === 'Installment Amount' ? true : subField.disabled, dateFormat: (subField.fieldDescription === 'Repayment Start Month' || subField.fieldDescription === 'Repayment End Month') ? 'mm/yy' : undefined, view: (subField.fieldDescription === 'Repayment Start Month' || subField.fieldDescription === 'Repayment End Month') ? 'month' : undefined})}
                                                            value={subField.fieldType === '3' && subField.fieldValue ? subField.fieldValue.split(",") : subField.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => this.handleChange(e, subField)}
                                                            {...this.props}
                                                            {...this.state}
                                                            metaData={this.metaDataFor(subField)} /></div>
                                                        )}
                                                        <div className="p-col-12 p-md-6 p-lg-4">
                                                            {editing && editing.parentFieldId === field.fieldName ? <div className="mt2" style={{ padding: '8px' }}>
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-pencil" onClick={this.updateEdit} label="Update" style={{ marginRight: '10px' }} />
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" onClick={this.cancelEdit} label="Cancel" />
                                                            </div> : <div className="mt2" style={{ padding: '8px' }}>
                                                                    <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-plus" onClick={() => this.handleContainer(field)} label="Add" />
                                                                </div>}
                                                        </div>
                                                        <div className="p-col-12">
                                                            <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                            expandableRowGroups={false} expandedRows={this.state.expandedRows} onRowToggle={(e) => { this.setState({ expandedRows: e.data }) }}
                                                            rowExpansionTemplate={this.rowExpansionTemplate} 
                                                            dataKey="childRowNmbr" rows={10} value={containerTable}>
                                                            <Column expander={true} style={{ width: '3em' }} />
                                                                {containerFields.map((columnField, columnIndex) =>
                                                                    (pageType == 'edit' & columnField.fieldDescription == 'Original Currency') ? <Column key={columnIndex} field={columnField.fieldDescription.replaceAll(' ', '_')} header={columnField.fieldDescription} body={this.currencyNameRender} /> : <Column key={columnIndex} field={columnField.fieldDescription.replaceAll(' ', '_')} header={columnField.fieldDescription} />
                                                                    )}
                                                                {
                                                                    ((pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null)) ? null : <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                                                }
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </Fieldset> : null}
                                    </div> : null

                                })}


                                {/* {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'VisitorPass'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null} */}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/materialpass-in'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    
                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <div className="p-col-12" style={{ paddingLeft: 0 }}>
                                            <Checkbox inputId="autoSendWhatsApp" checked={this.state.autoSendWhatsApp} onChange={(e) => this.setState({ autoSendWhatsApp: e.checked })} />
                                            <label htmlFor="autoSendWhatsApp" className="ml1">Auto-send WhatsApp quotation-request link to vendors on submit</label>
                                        </div>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary" label="Save" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger" label="Cancel" onClick={() => this.saveRequest('cancel')} />
                                        {pageType === 'edit' && <Button onClick={this.handleResendWhatsApp} className="p-button-help" label="Resend WhatsApp to Vendors" icon="pi pi-send" />}
                                        <Button onClick={() => this.generatePayslip('download')} className="p-button-success" label="Download PDF" icon="pi pi-file-pdf" />
                                        <Link to={'/EmployeeLoan'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>                                       
                                    </div>}
                            </div>
                        </div>
                    </div>
                })}


                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

                <Dialog header="Required Fields" visible={!!this.state.requiredFieldsMessage} modal={true} style={{ width: '400px' }} closable={true}
                    footer={<Button label="Close" icon="pi pi-times" className="p-button-secondary" onClick={() => this.setState({ requiredFieldsMessage: '', requiredFieldsContainers: [] })} />}
                    onHide={() => this.setState({ requiredFieldsMessage: '', requiredFieldsContainers: [] })}>
                    <p style={{ whiteSpace: 'pre-line', fontWeight: 'normal' }}>{this.state.requiredFieldsMessage}</p>
                    {(this.state.requiredFieldsContainers || []).map((c, i) => (
                        <p key={i} style={{ margin: '0.25em 0', fontWeight: 'normal' }}><span style={{ fontWeight: 'bold' }}>{c.name}</span>: <span style={{ fontWeight: 'normal' }}>{c.fields.join(', ')}</span></p>
                    ))}
                </Dialog>

                <Dialog header="Send Quotation Request Links" visible={this.state.vendorLinksDisplay} modal={true} style={{ width: '650px' }} onHide={this.handleFinishVendorLinks}
                    footer={<Button label="Done" icon="pi pi-check" className="p-button-primary" onClick={this.handleFinishVendorLinks} />}>
                    <div className="p-grid">
                        {this.state.vendorLinks.map(vendor => (
                            <div key={vendor.vendorId} className="p-col-12" style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '10px' }}>
                                <div><strong>{vendor.vendorName}</strong>{vendor.phone ? ` (${vendor.phone})` : ' (no phone number on file)'}</div>
                                <div style={{ wordBreak: 'break-all', fontSize: '0.9em', color: '#555' }}>{vendor.link}</div>
                                {vendor.error ? <div style={{ color: '#c0392b', fontSize: '0.85em' }}>{vendor.error}</div> : null}
                                <Button
                                    label={vendor.sent ? 'Sent' : vendor.sending ? 'Sending...' : 'Send via WhatsApp'}
                                    icon="pi pi-send"
                                    disabled={!vendor.phone || vendor.sending || vendor.sent}
                                    className={vendor.sent ? 'p-button-secondary' : 'p-button-success'}
                                    style={{ marginTop: '6px' }}
                                    onClick={() => this.handleManualVendorSend(vendor.vendorId)}
                                />
                            </div>
                        ))}
                    </div>
                </Dialog>

            </div>

        );
    }







}

const mapStateToProps = state => {
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    const loggedUserDetail = state.auth.userObject || {};
    const subordinatesListData = state.master.subordinatesListData;
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName}-Self`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

    let relevantOptions = [];
    let countryList = state.master.Country || [];
    const hrTeam = parseInt(localStorage.getItem('hrTeam'));
    if (hrTeam) {
        relevantOptions = Employee.reduce((a, el) => {
            if (el.value !== loggedUserDetail.empID) {
                a.push(el);
            }
            return a;
        }, [Object.assign({}, Employee.find(list => list.value === loggedUserDetail.empID), { label: 'Self', id: loggedUserDetail.userID })]);
    } else {
        relevantOptions = (loggedUserDetail !== null) ? [{ label: `${loggedUserDetail.userName}(Self)`, value: loggedUserDetail.empID, id: loggedUserDetail.userID }].concat(subordinatesListData) : subordinatesListData;
    }
    return {
        loggedUserDetail,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData,
        Employee,
        EmployeeList: relevantOptions,
        currencyList: currencyList && currencyList || [],
        keywordValuesList,
        metaData: Object.assign({}, {
            "Requested For": relevantOptions,
            "Purchase Request Number": state.keyword.PR,
            "Line Item Number": state.keyword.OrgUnit,
            "Material / Service" : state.keyword.Ingredient|| [],
            "Vendors to Send RFQ": state.keyword.Vendor || [],
            "Unit": state.keyword.UOM || []
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddRequestforQuotation);